import createApolloClient from '../../core/createApolloClient/createApolloClient.client';
import gql from 'graphql-tag';

const client = createApolloClient();

const query = gql`
  query($listId: String!, $preview: Boolean) {
    UserListing(listId: $listId, preview: $preview) {
      id
      userId
      title
      description
      coverPhotoName
      isPublished
      basePrice
      category
      category2
      blockedDates{
        blockedDates
        reservationId
      }
      listingAddresses {
        id
        addressId
        city
        state
      }
      listPhotos {
        id
        name
      }
      user {
        email
        profile {
          firstName
          lastName
          dateOfBirth
        }
      }
      listingRules {
        id
        description
      }
    }
  }
`;

export async function getListingData(listId) {
  // try {
  // Send Request to get listing data
  // console.log('GETTING LISTING DATA 2', listId);
  const { data } = await client.query({
    query,
    variables: { listId, preview: true },
    fetchPolicy: 'network-only',
  });

  // console.log('Listing queried successfully', data);
  if (data && data.UserListing) {
    return data.UserListing;
  }

  return false;
}

export async function ManagePublishStatus(listId, action) {
  let mutation = gql`
    mutation ManagePublish($listId: Int!, $action: String!) {
      managePublish(listId: $listId, action: $action) {
        status
      }
    }
  `;

  try {
    let type = 'Publish Listing';
    if (action === 'unPublish') {
      type = 'UnPublish Listing';
    }

    const { data } = await client.mutate({
      mutation,
      variables: {
        listId,
        action,
      },
      // refetchQueries: [{ query: ManageListingQuery }]
    });

    if (data.managePublish.status === '200') {
      // Reload Existing Steps Page
      return true;
    } else {
      console.log('Failed to publish - ', error);
    }
  } catch (error) {
    console.log('Error publishing - ', error);
  }
}



// WEBPACK FOOTER //
// ./src/components_new/addListing/getListingQL.js